<template>
    <div>
        <pasargad v-if="psp=='PASARGAD'" :form_data="parent"></pasargad>
        <novin v-if="psp=='NOVIN'" :form_data="parent"></novin>
    </div>
</template>
<script>

import {mapGetters} from "vuex";
import {customerType} from '@/constants/posNovin'
import NovinMerchantDocuments from './novin-merchant-documents'
import PasargadMerchantDocuments from './pasargad-merchant-documents'

export default {
    name:'merchant-documents',
    components: {
       'pasargad': PasargadMerchantDocuments,'novin':NovinMerchantDocuments
    },
    data() {
        return {
            customerType,
        }
    },
    props: {
        parent: {
            type :Object
        } ,
    },
    computed: {
        ...mapGetters('pos', [
            'psp',
        ])
    },
    mounted(){}
}
</script>

<style>
a, button {
    color: #4fc08d;
}

button {
    background: none;
    border: solid 1px;
    border-radius: 2em;
    padding: 0.75em 2em;
}
</style>